import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { 
  Avatar, 
  Box, 
  Button, 
  Card, 
  CardActions, 
  CardActionArea, 
  CardHeader, 
  CardContent, 
  Divider,
  FormControl, 
  FormHelperText, 
  Grid, 
  IconButton, 
  InputAdornment,
  Menu, 
  MenuItem,
  OutlinedInput,
  Paper, 
  TextField, 
  Typography 
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import axiosConfig from '../../../../../../utils/axiosConfig';

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(0.5),
    marginLeft: 0
  },
  textField: {
    width: '25ch',
  },
  table: {
    minWidth: 650,
  },
  input: {
    padding: "10px 14px"
  },
  helper: {
    marginLeft: 0,
    color: 'green',
    fontWeight: 'bold'
  }
}));

const GradingForm = (props) => {

  const classes = useStyles();
  const [gradeValue, setGradeValue] = useState(props.classworkGradeInfo.grade);
  const [successMsg, setSuccessMsg] = useState(null);

  const handleGradeChange = (grade) => {
    axiosConfig.post(`/grades`, { 
      student_grade_id: props.classworkGradeInfo.student_grade_id,
      grade
    })
    .then((res) => {
      if (res.data.status_code == 'ok') {
        setSuccessMsg('Saved ✓');
      }
    })
    .catch((err) => {
      console.log(err);
    });
  }

  useEffect(() => {
    if (gradeValue !== props.classworkGradeInfo.grade) {
      const timeOutId = setTimeout(() => handleGradeChange(gradeValue), 500);
      return () => clearTimeout(timeOutId);
    }

  }, [gradeValue]);

  return (
    <>
      <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
        <Typography>
          <b>Enter Student's Grade:</b>
        </Typography>

        <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined">
          <OutlinedInput
            classes={{ input: classes.input }}
            type="number"
            id="outlined-adornment-weight"
            endAdornment={<InputAdornment position="end">/{props.classworkGradeInfo.total_pts || 0}</InputAdornment>}
            aria-describedby="outlined-weight-helper-text"
            value={gradeValue}
            onChange={event => {setSuccessMsg(''); setGradeValue(event.target.value.replace(/\D/,'')); }}
            // disabled={authState.user.role_id === 5}
          />
          {successMsg && (
            <FormHelperText className={classes.helper}>
              {successMsg}
            </FormHelperText>
          )}
        </FormControl>
      </Grid>
    </>
  );
}

export default GradingForm;